/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepliconUserStatusResponse
 */
export interface RepliconUserStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RepliconUserStatusResponse
     */
    isRepliconUser: boolean;
}

/**
 * Check if a given object implements the RepliconUserStatusResponse interface.
 */
export function instanceOfRepliconUserStatusResponse(value: object): value is RepliconUserStatusResponse {
    if (!('isRepliconUser' in value) || value['isRepliconUser'] === undefined) return false;
    return true;
}

export function RepliconUserStatusResponseFromJSON(json: any): RepliconUserStatusResponse {
    return RepliconUserStatusResponseFromJSONTyped(json, false);
}

export function RepliconUserStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepliconUserStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isRepliconUser': json['isRepliconUser'],
    };
}

export function RepliconUserStatusResponseToJSON(value?: RepliconUserStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isRepliconUser': value['isRepliconUser'],
    };
}

